<script>
export default {
  name: 'SpeechToText',
  props: {
    value: {
      type: String,
      default: '',
    },
    lang: {
      type: String,
      default: 'en-US',
    },
    type: {
      type: String,
      default: 'textarea',
    },
    placeholder: {
      type: String,
      default: 'Text',
    },
  },
  data: () => ({
    active: false,
    runtimeTranscription: '',
    transcription: '',
    prevTranscription: '',
    recognition: {},
  }),
  watch: {
    transcription(newValue, oldValue) {
      this.$emit('update:value', this.transcription)
    },
    value: {
      handler(newVal, oldVal) {
        this.transcription = newVal
      },
      immediate: true,
    },
  },
  mounted() {
    window.SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition
    if (!window.SpeechRecognition && process.env.NODE_ENV !== 'production') {
      throw new Error(
        'Speech Recognition does not exist on this browser. Use Chrome or Firefox'
      )
    }
    if (!window.SpeechRecognition) {
      console.warn('No speech recognition')
    }
    this.recognition = new window.SpeechRecognition()
  },
  methods: {
    record() {
      if (!this.active) {
        this.start()
      } else {
        this.stop()
      }
    },
    start() {
      this.active = true
      this.checkApi()
    },
    stop() {
      this.recognition.stop()
    },
    checkApi() {
      this.recognition.lang = this.lang
      this.recognition.interimResults = true
      this.recognition.addEventListener('result', (event) => {
        const text = Array.from(event.results)
          .map((result) => result[0])
          .map((result) => result.transcript)
          .join('')
        this.runtimeTranscription = text
      })
      this.recognition.addEventListener('end', () => {
        this.active = false
        if (
          this.runtimeTranscription !== '' &&
          this.runtimeTranscription !== this.prevTranscription
        ) {
          this.prevTranscription = this.runtimeTranscription
          this.transcription += ' ' + this.runtimeTranscription
          this.$emit('onTranscriptionEnd', {
            transcription: this.transcription,
            lastSentence: this.runtimeTranscription,
          })
        }
      })
      this.recognition.start()
    },
  },
}
</script>

<template>
  <v-container class="fill-height ma-0 pa-0 rounded-xl">
    <v-text-field
      v-if="type === 'textfield'"
      v-model="transcription"
      v-bind="$attrs"
      hide-details
      :placeholder="placeholder"
    >
      <template v-slot:append>
        <v-btn :class="active ? $style.pulse : ''" fab small @click="record">
          <v-icon>mdi-microphone</v-icon>
        </v-btn>
      </template>
    </v-text-field>
    <v-textarea
      v-if="type === 'textarea'"
      v-model="transcription"
      v-bind="$attrs"
      hide-details
      :placeholder="placeholder"
    >
      <template v-slot:append>
        <v-btn :class="active ? $style.pulse : ''" fab small @click="record">
          <v-icon>mdi-microphone</v-icon>
        </v-btn>
      </template>
    </v-textarea>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.pulse {
  animation: $pulse;
}

@keyframes pulse-animation {
  0% {
    box-shadow: $box-shadow-on;
  }
  100% {
    box-shadow: $box-shadow-off;
  }
}
</style>
